import { NavigationByWeeksContext } from '@/scopes/prices/components/PriceTableByWeeks/NavigationByWeeksContext'
import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Icon } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { css, styled } from 'styled-components'

interface NavigationByWeeksProps {
  children?: React.ReactNode
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${space('primitives_space_4')};
`

const NavigationBlock = styled.div<{ $disabled?: boolean }>`
  display: none;
  @media (min-width: ${tokPx('primitives_breakpoint_m_min')}) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: auto;
    background: ${tok('primitives_color_neutral_100')};
    border-radius: ${tokPx('primitives_corner_radius_m')};
    cursor: pointer;
    &:hover {
      background: ${tok('primitives_color_neutral_200')};
    }
  }

  ${({ $disabled }) => $disabled && css`
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.38;
  `}
`
const NavigationBlockLeft = styled(NavigationBlock)`
  margin-right: ${space('primitives_space_6')};
`

export function NavigationByWeeks({ children }: NavigationByWeeksProps) {
  const { navigateRight, navigateLeft, isNavigationLeftEnabled, isNavigationRightEnabled } = React.useContext(NavigationByWeeksContext)

  return (
    <Wrapper>
      <NavigationBlockLeft onClick={navigateLeft} $disabled={!isNavigationLeftEnabled}>
        <Icon glyph="ChevronLeft" />
      </NavigationBlockLeft>
      {children}
      <NavigationBlock onClick={navigateRight} $disabled={!isNavigationRightEnabled}>
        <Icon glyph="ChevronRight" />
      </NavigationBlock>
    </Wrapper>
  )
}
